var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsDocumentPageFillBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Labels"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Labels-2",
    "data-name": "Labels"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.16,33.94a1.16,1.16,0,0,0-.26-.39L59.63,14.35a1.31,1.31,0,0,0-.4-.26,1.22,1.22,0,0,0-.46-.09H24.46a3.71,3.71,0,0,0-3.71,3.71V82.3a3.7,3.7,0,0,0,3.7,3.7H75.54a3.71,3.71,0,0,0,3.71-3.71V34.4A1.22,1.22,0,0,0,79.16,33.94ZM47.75,72.87h-18v-9h18Zm22.5-18H29.75v-9h40.5ZM58,35.17V20.07l15.16,15.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsDocumentPageFillBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_DocumentPage_Fill_Black_RGB.11dce8b267a76d17011fa4597125f5ad.svg";
export { ForwardRef as ReactComponent };